import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { UserApi } from '../../../services/shared/sdk';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-solicitud-baja',
  templateUrl: './solicitud-baja.component.html',
  styleUrls: ['./solicitud-baja.component.scss']
})
export class SolicitudBajaComponent implements OnInit {

  constructor(
    public dialogRef : MatDialogRef<SolicitudBajaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _user : UserApi,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  confirm(resp) {
    resp = resp == 'true' ? true : false;
    this._user.deletionRequestConfirm(this.data.id, resp).subscribe((resp) => {
      let message = resp ? 'Solicitud aceptada!' : 'Solicitud rechazada!';
      this.snackBar.open(message, 'Listo!', {
        duration: 2000
      });
      this.dialogRef.close();
    });
  }
}
